import React from 'react'
import Image from 'next/image'
import Link from 'next/link'

import { useTenant } from '@rewardops/auth/src/client/use-tenant'
import { cn, useLocale } from '@rewardops/ui'

interface BirchLogoProps {
  className?: string
}

const BirchLogo = ({ className }: BirchLogoProps) => {
  const tenant = useTenant()
  const { language } = useLocale()
  const logo =
    (tenant.logo as any)?.[language] ??
    Object.values((tenant.logo as any) || {})[0]

  return (
    logo && (
      <Link
        href="/"
        className={cn('mt-2 h-[32px] w-16 text-black md:my-1', className)}
      >
        <div className="z-20 ml-0 cursor-pointer pl-0 text-xs opacity-80 hover:opacity-100">
          <Image src={logo.url} alt="Logo" height={32} width={144} />
        </div>
      </Link>
    )
  )
}

export { BirchLogo }
